import Vue from 'vue'
import {CONSTANTS_PROD, CONSTANTS_TEST, TEST_ENVIRONMENT} from '../../config/constants'
import axios from 'axios'
import {bus} from '../../components/Dealers/bus-dealers'
import _ from "lodash";

export var dealers_service = new Vue({
    data() {
        return {
            constants: {},
            full_url: ''
        }
    },
    methods: {
        async GetAllRestaurant() {
            await axios({
                method: 'POST',
                url: this.full_url + 'search/restaurant_index',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {

                    bus.GetAllRestaurant(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllDealers() {
            await axios.get(this.full_url + 'users/filter/2')
                .then(function (response) {
                    bus.GetAllDealer(_.map(response.data.body.hits.hits, "_source"), response.data.body.hits.total)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllDealerInforme2() {
            await axios({
                method: 'GET',
                url: this.full_url + 'users/filter/2',
                data: {
                    from: 0,
                    size: 10000
                }
            })
                .then(function (response) {
                    bus.GetAllDealerInforme(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        async GetAllDealerInforme() {
            await axios({
                method: 'GET',
                url: this.full_url + 'users/getuserBytype/4'
            })
                .then(function (response) {
                    bus.GetAllDealerInforme(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllOrderStatus() {
            await axios.get(this.full_url + 'orderstatus')
                .then(function (response) {
                    bus.GetAllOrderStatus(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetAllDealerPagination(page) {
            //console.log(page)
            await axios({
                method: 'POST',
                url: this.full_url + 'users/filter/2',
                data: {
                    from: page,
                    size: 10
                }
            })
                .then(function (response) {
                    console.log("llego", _.map(response.data.body.hits.hits, "_source"))
                    bus.GetAllDealerPagination(_.map(response.data.body.hits.hits, "_source"))
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async CreateDealer(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'users',
                data: data
            })
                .then(function (response) {
                    bus.ResponseCreateDealer(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateDealer(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'users',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateDealer(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetUsersByType(id) {
            await axios({
                method: 'GET',
                url: this.full_url + 'users/getuserBytype/' + id
            })
                .then(function (response) {
                    bus.GetUsersByType(response.data)
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        async GetRepartidorOrder(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/orderdelivery',
                data: data
            })
                .then(function (response) {
                    bus.GetRepartidorOrder(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetRepartidorOrderV1(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/oldorderdelivery',
                data: data
            })
                .then(function (response) {
                    bus.GetRepartidorOrder(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetRepartidorAllOrder(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/allorderdelivery',
                data: data
            })
                .then(function (response) {
                    bus.GetRepartidorOrder(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetRepartidorAllOrderV1(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'order/oldallorderdelivery',
                data: data
            })
                .then(function (response) {
                    bus.GetRepartidorOrder(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetUserAndRest(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'users/userandrest/' + data
            })
                .then(function (response) {
                    bus.GetUserAndRest(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async GetValidateUser(data) {
            await axios.get(this.full_url + 'users/valideuser/' + data)
                .then(function (response) {
                    bus.GetValdateUser(response.data)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateRestaurant(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'restaurant',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateRestaurant(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async UpdateUsers(data) {
            await axios({
                method: 'PUT',
                url: this.full_url + 'users',
                data: data
            })
                .then(function (response) {
                    bus.ResponseUpdateRestaurant(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        },
        async DeleteUser(data) {
            await axios({
                method: 'POST',
                url: this.full_url + 'users/deleteat',
                data: data
            })
                .then(function (response) {
                    bus.DeleteUser(response)
                })
                .catch(function (error) {
                    console.log('Error ' + error);
                })
        }
    },
    created() {
        (TEST_ENVIRONMENT) ? this.constans = CONSTANTS_TEST : this.constans = CONSTANTS_PROD;
        this.full_url = this.constans.URL_API + this.constans.VERSION_API;
    }
});
